import styled from "styled-components";

export const SelectRangeModalWrapper = styled.div`
    .selectRangeWrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-family: var(--base-font-sans-serif);
        position: relative;
        @media (min-width: 470px) {
            flex-direction: row;
        }
    }
    .close-icon {
        background: ${({theme}) => theme?.light?.primary};
        position: absolute;
        top: -12px;
        right: 0px;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        z-index: 10;
        img {
            width: 12px;
            height: 12px;
        }
    }
    .filter-div {
       display: flex;
       flex-direction: row;
       justify-content: center;
       gap: 10px;
       width: 100%;
        /* margin-top: auto; */
        @media (min-width: 470px){
            width: 50%;
            flex-direction: column;
        }
        h2 {
            font-size: 20px;
            font-weight: 600;
            line-height: 24px;
        }
        .inner-container {
            display: flex;
            align-items: flex-start;
            gap: 7px;
            background-color: #f6f8fa;
            border-radius: 10px;
            /* width: 100%; */
            padding: 10px 10px 10px 10px;
            min-height: 60px;
            margin-bottom: 16px;
            .desc {
                display: flex;
                flex-direction: column;
                gap: 0px;
                h6 {
                    font-size: 14px;
                    font-weight: 600;
                }
                span {
                    font-size: 14px;
                    font-weight: 300;
                    color: ${({theme}) => theme?.light?.primary};
                }
            }
        }
    }
    .date-picker {
        .react-datepicker {
            box-shadow: none !important;
            .react-datepicker__header {
                padding-top: 0px;
            }
            .react-datepicker__month {
                color: ${({theme}) => theme?.light?.primary};
            }
            .react-datepicker__day {
                color: ${({theme}) => theme?.light?.primary};
                font-size: 14px;
                font-weight: 500;
            }
            .react-datepicker__day-name {
                border: 1px solid #f6f8fa;
                border-radius: 40px;
                font-size: 14px;
                font-weight: 500;
                /* color: #cdcdcd; */
                color: var(--black);
            }
            .react-datepicker__day--selected,
            .react-datepicker__day--range-end {
                color: var(--white) !important;
                background-color: ${({theme}) => theme?.light?.primary} !important;
                border-radius: 50px;
            }
            .react-datepicker__day--in-range {
                color: var(--white);
                background-color: ${({theme}) => theme?.light?.primary};
                border-radius: 50px;
            }
            .react-datepicker__day--keyboard-selected {
                background-color: ${({theme}) => theme?.light?.primary50};
            }
            .react-datepicker__day:not([aria-disabled="true"]):hover {
                background-color: ${({theme}) => theme?.light?.primary50};
            }
        }
    }

    .btn-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        button {
            width: 100px;
            padding: 10px 15px;
            @media (min-width: 576px){
                width: 200px;
            }
        }
    }
`;
